define([
	"dojo/_base/declare",
	"csi",
	"csi/view/ToolbarPluginSwitchboard",
	"Apparel/StructureItemMixin"
], function(declare,csi,ToolbarPluginSwitchboard,StructureItemMixin) {

	return declare([ToolbarPluginSwitchboard, StructureItemMixin], {
		bSupportsExcel: true,

		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: resolve relationship path and/or filters
			var	view = this.actionToolbar.view;
			this._resolveViewPath(view, r);
			this._resolveViewFilter(view, r);

			return this.inherited(arguments);
		}
	});
});